import { BadgeCheck, ShieldCheck, Award } from "lucide-react";

export const LifetimeBadge = ({ testId, className = "", title }) => (
  <span data-testid={testId} title={title || "Bought a machine from FLS — lifetime free technical support"} className={`inline-flex items-center gap-1 rounded-sm border border-amber-400/50 bg-amber-400/10 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-amber-300 ${className}`}>
    <Award className="h-3 w-3" /> Lifetime support
  </span>
);

export const OfficialBadge = ({ testId, className = "" }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-sm border border-sky-500/40 bg-sky-500/10 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-sky-300 ${className}`}>
    <BadgeCheck className="h-3 w-3" /> FLS Official
  </span>
);

export const WarrantyBadge = ({ testId, className = "" }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-sm border border-emerald-500/40 bg-emerald-500/10 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-emerald-300 ${className}`}>
    <ShieldCheck className="h-3 w-3" /> FLS Warranty
  </span>
);

export const FeeBadge = ({ status, amount, testId, className = "" }) => {
  const map = {
    paid: ["border-rose-500/40 bg-rose-500/10 text-rose-300", `Priority · £${Number(amount || 30).toFixed(0)} paid`],
    lifetime: ["border-amber-400/50 bg-amber-400/10 text-amber-300", "Lifetime support"],
    staff: ["border-sky-500/40 bg-sky-500/10 text-sky-300", "Raised by FLS"],
    waived: ["border-emerald-500/40 bg-emerald-500/10 text-emerald-300", "Fee waived"],
    refunded: ["border-slate-600 bg-slate-800/60 text-slate-300", "Fee refunded"],
    included: ["border-rose-500/40 bg-rose-500/10 text-rose-300", "Priority · Included"],
    free: ["border-slate-600 bg-slate-800/60 text-slate-300", "Free ticket"],
    unpaid: ["border-amber-500/50 bg-amber-500/10 text-amber-300", "Awaiting payment"],
  };
  if (!map[status]) return null;
  const [cls, label] = map[status];
  return <span data-testid={testId} className={`inline-flex items-center rounded-sm border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${cls} ${className}`}>{label}</span>;
};

export const PrivateSaleNotice = ({ testId = "private-sale-disclaimer", compact = false }) => (
  <div data-testid={testId} className={`space-y-2 rounded-md border border-amber-500/20 bg-amber-500/5 px-3 py-2 leading-relaxed text-amber-200/80 ${compact ? "text-xs" : "text-xs sm:text-sm"}`}>
    <p><strong className="text-red-400">Sales Notice:</strong> Items listed in this section may be sold by private owners or directly by Focused Laser Systems Ltd (FLS).</p>
    <p>Machines sold by FLS will be clearly identified with the <OfficialBadge testId={`${testId}-official-badge`} className="mx-0.5 align-middle" /> badge.</p>
    <p>An FLS warranty is only included where explicitly indicated by the <WarrantyBadge testId={`${testId}-warranty-badge`} className="mx-0.5 align-middle" /> badge.</p>
  </div>
);
